"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonMenu2 = void 0;
var tslib_1 = require("tslib");
var kebabCase_1 = (0, tslib_1.__importDefault)(require("lodash/kebabCase"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var test_helpers_1 = require("../../lib/test-helpers");
var button_1 = require("../button");
var flexbox_1 = require("../flexbox");
var icons_1 = require("../icons");
var menu_2_1 = require("../menu-2");
var popper_1 = require("../popper");
var spacing_1 = require("../spacing");
function ButtonMenu2(_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, items = _a.items, width = _a.width, style = _a.style, propTestId = _a.testId;
    var testId = propTestId !== null && propTestId !== void 0 ? propTestId : (typeof children === 'string' ? (0, test_helpers_1.generateTestId)((0, kebabCase_1.default)(children.toString()), 'button-menu') : undefined);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(popper_1.Popper, { trigger: function (_a) {
                var triggerRef = _a.triggerRef, toggle = _a.toggle;
                return (react_1.default.createElement(button_1.Button, { type: "button", size: variant, elementRef: triggerRef, onClick: toggle, minWidth: width, style: style, testId: testId },
                    react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "center", alignItems: "center" },
                        children,
                        react_1.default.createElement(spacing_1.Spacing, { width: 4 }),
                        react_1.default.createElement(icons_1.IconCaret, { color: "currentColor" }))));
            } }, function (_a) {
            var toggle = _a.toggle;
            return react_1.default.createElement(menu_2_1.Menu, { items: items, onItemClick: toggle });
        })));
}
exports.ButtonMenu2 = ButtonMenu2;
//# sourceMappingURL=index.js.map